export const APP_SETTINGS_START_LOADING = 'app/settings/startLoading';

export type StartLoadingAppSettingsAction = {
  type: typeof APP_SETTINGS_START_LOADING;
};
export const startLoadAppSettings = (): StartLoadingAppSettingsAction => ({
  type: APP_SETTINGS_START_LOADING,
});
